module.exports = __webpack_public_path__ + "static/media/Airtime.780ef2ea.svg";